import styled from 'styled-components'

const OneLineTitleCloneStyled = styled.div`
  background-color: transparent;
  padding-bottom: 57px;

  .text {
    text-transform: uppercase;
    color: #4EF076;
  }

  .total {
    color: #FFF566;
  }
`

export default OneLineTitleCloneStyled
